/** Animasyon süreleri ve easing sabitleri */
export const animationConfig = {
  previewEnterMs: 380,
  previewPulseScale: 1.03,
  previewPulseMs: 900,
  previewExitMs: 280,
  gridStaggerDelayMs: 42,
  gridEnterMs: 300,
  hintFadeMs: 160,
  correctOverlayMs: 220,
  correctBounceScale: 1.1,
  correctBounceMs: 320,
  correctDimAlpha: 0.28,
  correctRoundGapMs: 350,
  wrongOverlayMs: 260,
  wrongShakeDurationMs: 380,
  wrongShakeIntensity: 0.005,
  wrongHoldMs: 950,
  scorePunchScale: 1.18,
  scorePunchMs: 280,
} as const;

export const animationEase = {
  outBack: 'Back.easeOut',
  outCubic: 'Cubic.easeOut',
  inCubic: 'Cubic.easeIn',
  outQuad: 'Quad.easeOut',
} as const;
